module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_a-function.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_a-function.js
// module chunks = common